import * as $ from 'jquery'

export class DatepickerHelper {
    static readonly DATE_FORMAT = 'YYYY.MM.DD ddd'
    static readonly DATEPICKER_SELECTOR = '.bootstrap-datetimepicker-widget'
    static readonly DAY_SELECTOR = '.bootstrap-datetimepicker-widget .datepicker .day, .bootstrap-datetimepicker-widget [data-action=\'today\']'
    static readonly BASE_OPTIONS: object = {
        format: 'YYYY.MM.DD ddd',
        showTodayButton: true,
        useCurrent: false,
        keepOpen: true,
        debug: true,
    }

    static readonly BASE_NONE_TODAY_OPTIONS: object = {
        format: 'YYYY.MM.DD ddd',
        keepOpen: true,
        debug: true,
    }

    static readonly BASE_NONE_FORMAT_OPTIONS: object = {
        keepOpen: true,
        debug: true,
    }

    static readonly BASE_HIDE_OPTIONS: object = {
        format: 'YYYY.MM.DD ddd',
        showTodayButton: true,
        useCurrent: false,
        keepOpen: false,
        debug: false,
    }

    /**
     * Trigger click to hide Datepicker
     */
    static hideOnSelectDate(): void {
        $(document).off('click', '.bootstrap-datetimepicker-widget .datepicker .day, .bootstrap-datetimepicker-widget [data-action=\'today\']')
        $(document).on('click', '.bootstrap-datetimepicker-widget .datepicker .day, .bootstrap-datetimepicker-widget [data-action=\'today\']', () => {
            this.hideWidget()
        })
    }

    static showWidget(hideOnSelect = false) {
        $(this.DATEPICKER_SELECTOR).show()
        if (hideOnSelect) {
            //this.hideOnSelectDate();
        }
    }

    static hideWidget() {
        $(this.DATEPICKER_SELECTOR).hide()
    }
}



// WEBPACK FOOTER //
// ./src/helper/datepicker.helper.ts